import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import { TOPBAR_POSITION } from '@bridebook/web/lib/app-bar/constants';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
}

interface IStyleArgs {
  style: FelaCSS;
  offsetTop: number;
  topStyle: FelaCSS;
  scrolledStyle: FelaCSS;
}

const onTopSelector = `&.${TOPBAR_POSITION.ONTOP}`;
const scrolledSelector = `&.${TOPBAR_POSITION.SCROLLED}`;

const styles = ({ style, offsetTop, topStyle, scrolledStyle }: IStyleArgs): IStyles => ({
  wrapper: mergeStyles([
    {
      position: 'fixed',
      width: '100%',
      zIndex: 200,
      top: offsetTop,
      left: 0,

      supportsSafeAreaInset: {
        paddingTop: 'env(safe-area-inset-top)',
      },

      transition: `
        background 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000),
        box-shadow 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000)
      `,

      [onTopSelector]: {
        ...topStyle,
      },

      [scrolledSelector]: {
        background: colors.white,
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        ...scrolledStyle,
      },
    },
    style,
  ]),
});

export default styles;
